import Vue from 'vue'
import VueRouter from 'vue-router'
import Careers from '../views/Careers.vue'
import DynamicCareer from '../views/DynamicCareer.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/careers/jobs/',
    name: 'careerSearch',
    component: Careers
  },
  {
    path: '/careers/*',
    'name': 'dynamicCareerSearch',
    component: DynamicCareer,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
